export default __webpack_public_path__ + "static/media/logo.73e3f63e.svg";